<template>
  <div class="page-box">
    <div class="content">
      <div class="card-1">
        <div class="card-item" @click="$router.push({ name: 'DataAnalysisViews' })">
          <div class="title-box">
            <span>销售总额</span>
            <el-tooltip class="item" effect="dark" content="包含拓客宝内所有小程序端用户支付的报名、秒杀、拼团总收入金额 (包含已退款金额)。" placement="top">
              <i class="el-icon-warning-outline"></i>
            </el-tooltip>
          </div>
          <div class="number">{{totalText.totalSales || 0}}</div>
          <div class="row-1">
            <div class="row-item">
              <span>日环比</span>
              <i class="el-icon-caret-top top" v-if="parseInt(totalText.dayChain) >= 0"></i>
              <i class="el-icon-caret-bottom bottom" v-else-if="totalText.dayChain && parseInt(totalText.dayChain) < 0"></i>
              <span>  {{totalText.dayChain}}%</span>
            </div>
            <div class="row-item">
              <span>周对比</span>
              <i class="el-icon-caret-top top" v-if=" parseInt(totalText.weekChain) >= 0"></i>
              <i class="el-icon-caret-bottom bottom" v-else-if="totalText.weekChain && parseInt(totalText.weekChain) < 0"></i>
              <span>  {{totalText.weekChain}}%</span>
            </div>
          </div>
          <div class="row-2">
            <span>今日销售额</span>
            <span class="row-2-number">¥ {{totalText.todaySales || 0}}</span>
          </div>
        </div>
        <div class="card-item" @click="$router.push({ name: 'WeChatData' })">
          <div class="title-box">
            <span>访问总量</span>
            <el-tooltip class="item" effect="dark" content="用户访问小程序的访问总量。" placement="top">
              <i class="el-icon-warning-outline"></i>
            </el-tooltip>
          </div>
          <div class="number">{{totalText.totalVisits || 0}}</div>
          <div class="row-1 line">
            <lin-chart />
          </div>
          <div class="row-2">
            <span>今日访问量</span>
            <span class="row-2-number">{{totalText.todayVisits}}</span>
          </div>
        </div>
        <div class="card-item" @click="$router.push({ name: 'DataAnalysisViews' })">
          <div class="title-box">
            <span>总顾客数</span>
            <el-tooltip class="item" effect="dark" content="包含拓客宝小程序内参与所有报名、抽奖、秒杀和拼团的总顾客数。" placement="top">
              <i class="el-icon-warning-outline"></i>
            </el-tooltip>
          </div>
          <div class="number">{{totalText.totalCustomers || 0}}</div>
          <div class="row-1 line">
            <bar-chart />
          </div>
          <div class="row-2">
            <span>今日顾客数</span>
            <span class="row-2-number">{{totalText.todayCustomers}}</span>
          </div>
        </div>
        <div class="card-item" @click="$router.push({ name: 'withdrawalList' })">
          <div class="title-box">
            <span>总提现金额</span>
            <el-tooltip class="item" effect="dark" content="包含所有经销商已提现的金额总数" placement="top">
              <i class="el-icon-warning-outline"></i>
            </el-tooltip>
          </div>
          <div class="number">{{totalText.totalWithdrawn || 0}}</div>
          <div class="row-1">
            <div class="row-item">
              <span>待提现总数：</span>
              <span>{{totalText.totalWaitWithdrawn}}</span>
            </div>
          </div>
          <div class="row-2 item4">
            <span>今日提现数</span>
            <span class="row-2-number">¥ {{totalText.todayWithdrawn}}</span>
          </div>
        </div>
        <div class="card-item">
          <div class="title-box">
            <span>报名成交率(仅定制业务)</span>
            <el-tooltip class="item" effect="dark" content="成交率计算=累计报名成交数 / 累计报名总订单数" placement="top">
              <i class="el-icon-warning-outline"></i>
            </el-tooltip>
          </div>
          <div class="number">{{signUpSuccessRate.closingRate || 0}}</div>
          <div class="row-1">
            <div class="row-item">
              <span>总报名成交数：</span>
              <span>{{signUpSuccessRate.totalOrderNum}}</span>
            </div>
          </div>
          <div class="row-2 item4">
            <span>今日报名成交数</span>
            <span class="row-2-number">{{signUpSuccessRate.closingOrderNum}}</span>
          </div>
        </div>
        
      </div>
      <div class="card-2">
        <div class="search-box">
          <div class="select-box">
            <span class="label">数据范围：</span>
            <el-select v-model="searchForm.orgCode" placeholder="请选择" size="small" @change="orgCodeChange">
              <el-option label="全部" value=""></el-option>
              <el-option v-for="item in officeList" :key="item.code" :label="item.name" :value="item.code"> </el-option>
            </el-select>
            <el-date-picker
              class="data-picker"
              size="small"
              @change="timeChange"
              v-model="searchForm.time"
              :default-time="['00:00:00', '23:59:59']"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="daterange"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :clearable="false"
              :editable="false"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </div>
          <div class="tab-select">
            <span class="label">指标筛选：</span>
            <el-radio-group v-model="searchForm.type" size="small" @input="rankingDataList">
              <el-radio-button :label="item.label" v-for="(item,index) in typeList" :key="index">{{item.name}}</el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <div class="card-box">
          <!-- <div class="card-item" @click="$router.push({ name: 'DataAnalysisViews' })"> -->
          <div class="card-item">
            <map-chart ref="chinaMap" :officeList="officeList" @mapSearch="mapSearch"/>
          </div>
          <div class="card-item" v-loading="loading">
            <div class="head-box">
              <span>区域{{typeList[searchForm.type - 1].name}}排行榜</span>
              <el-link class="link" type="success" :underline="false" @click="$router.push({ name: 'dataList',query: {...searchForm,updatedTime: searchForm.time} })">查看更多</el-link>
            </div>
            <office-chart :orgList="orgList" ref="office" />
          </div>
          <div class="card-item" v-loading="loading">
            <div class="head-box">
              <span>经销商{{typeList[searchForm.type - 1].name}}排行榜</span>
              <el-link class="link" type="success" :underline="false" @click="$router.push({ name: 'dealerList',query: {...searchForm,updatedTime: searchForm.time,parentIdCode: searchForm.orgCode} })">查看更多</el-link>
            </div>
            <dealer-chart :cusList="cusList" ref="dealer"/>
          </div>
        </div>
      </div>
      <div class="card-3">
        <div class="chatsTitle">数据总览</div>
        <div class="head-box">
          <div class="head-left">
            <!-- <span class="label">指标筛选</span> -->
            <!-- <el-tabs class="tabs" v-model="searchForm.findType" @tab-click="rangeQueryDataList">
              <el-tab-pane label="销售总额" name="1">销售总额</el-tab-pane>
              <el-tab-pane label="访问总量" name="2">访问总量</el-tab-pane>
              <el-tab-pane label="总顾客数" name="3">总顾客数</el-tab-pane>
              <el-tab-pane label="报名人数" name="4">报名人数</el-tab-pane>
              <el-tab-pane label="报名退款" name="5">报名退款</el-tab-pane>
              <el-tab-pane label="报名待核销" name="6">报名待核销</el-tab-pane>
              <el-tab-pane label="秒杀人数" name="7">秒杀人数</el-tab-pane>
              <el-tab-pane label="秒杀待核销" name="8">秒杀待核销</el-tab-pane>
              <el-tab-pane label="拼团人数" name="9">拼团人数</el-tab-pane>
              <el-tab-pane label="拼团退款" name="10">拼团退款</el-tab-pane>
              <el-tab-pane label="拼团待核销" name="11">拼团待核销</el-tab-pane>
              <el-tab-pane label="总待提现" name="12">总待提现</el-tab-pane>
              <el-tab-pane label="总提现" name="13">总提现</el-tab-pane>
            </el-tabs> -->
            <span class="label">指标筛选：</span>
            <el-select v-model="searchForm.findType" placeholder="请选择" size="small" @change="rangeQueryDataList">
              <el-option v-for="item in findTypeList" :key="item.value" :label="item.name" :value="item.value"> </el-option>
            </el-select>
          </div>
          <div class="head-right">
            <el-radio-group class="group" v-model="searchForm.timeType" size="small" @input="rangeQueryDataList('time')">
              <el-radio-button label="1">本周</el-radio-button>
              <el-radio-button label="2">本月</el-radio-button>
              <el-radio-button label="3">全年</el-radio-button>
            </el-radio-group>
            <el-button type="primary" @click="exportData">导出</el-button>
          </div>
        </div>
        <div class="chart" v-loading="loading2">
          <bar-large ref="large" :largeList="largeList" />
        </div>
      </div>
      <div  v-loading="loading3">
        <div class="card-4">
          <div class="head-box">
            <span>报名数据</span>
            <el-link class="link" type="success" :underline="false" @click="$router.push({ name: 'signupData' })">查看更多</el-link>
          </div>
          <div class="card-item-box">
            <div class="item">
              <div class="title">报名人数</div>
              <div class="number">{{bottomText.signUpNum}} <span class="unit">人</span></div>
              <div class="row-text">累计报名总人数：{{bottomText.totalSignUpNum}}人</div>
              <div class="row">
                <div class="row-left">今日报名人数：{{bottomText.todaySignUpNum}}人</div>
                <div class="row-right">较昨天：<span :style="{ color: numberTypeColor(bottomText.dayChainSignUpNum) }">{{numberTypeSymbol(bottomText.dayChainSignUpNum)}}{{bottomText.dayChainSignUpNum}}%</span></div>
              </div>
            </div>
            <div class="item">
              <div class="title">报名待核销</div>
              <div class="number">{{bottomText.waitVerificationAmount}} <span class="unit">元</span></div>
              <div class="row-text">累计报名待核销总金额：{{bottomText.totalWaitVerification}}元</div>
              <div class="row">
                <div class="row-left">今日待核销：{{bottomText.todayWaitVerification}}元</div>
                <div class="row-right">较昨天：<span :style="{ color: numberTypeColor(bottomText.dayChainWaitVerification) }">{{numberTypeSymbol(bottomText.dayChainWaitVerification)}}{{bottomText.dayChainWaitVerification}}%</span></div>
              </div>
            </div>
            <div class="item">
              <div class="title">报名退款</div>
              <div class="number">{{bottomText.signUpRefund}} <span class="unit">元</span></div>
              <div class="row-text">累计报名总退款数：{{bottomText.totalRefund}}元</div>
              <div class="row">
                <div class="row-left">今日退款：{{bottomText.todayRefund}}元</div>
                <div class="row-right">较昨天：<span :style="{ color: numberTypeColor(bottomText.dayChainRefund) }">{{numberTypeSymbol(bottomText.dayChainRefund)}}{{bottomText.dayChainRefund}}%</span></div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-5">
          <div class="card-item left">
            <div class="head-box">
              <span>秒杀数据</span>
              <el-link class="link" type="success" :underline="false" @click="$router.push({ name: 'spikeData' })">查看更多</el-link>
            </div>
            <div class="card-item-box">
              <div class="item">
                <div class="title">秒杀人数 | 总金额</div>
                <div class="number-box">
                  <div class="number">{{bottomText.seckillNum}}<span class="unit">人</span></div>
                  <div class="number">{{bottomText.seckillAmount}}<span class="unit">元</span></div>
                </div>
                <div class="row">
                  <span class="key">累计人数 | 总金额：</span>
                  <div>{{bottomText.totalSekillNum}}人/{{bottomText.totalSekill}}元</div>
                </div>
                <div class="row">
                  <span class="key">今日秒杀人数：{{bottomText.todaySekillNum}}人</span>
                  <div class="value">较昨天日：<span :style="{ color: numberTypeColor(bottomText.dayChainSekillNum) }">{{numberTypeSymbol(bottomText.dayChainSekillNum)}}{{bottomText.dayChainSekillNum}}%</span></div>
                </div>
                <div class="row">
                  <span class="key">今日秒杀金额：{{bottomText.todaySekill}}元</span>
                  <div class="value">较昨天日：<span :style="{ color: numberTypeColor(bottomText.dayChainSekill) }">{{numberTypeSymbol(bottomText.dayChainSekill)}}{{bottomText.dayChainSekill}}%</span></div>
                </div>
              </div>
              <div class="item">
                <div class="title">秒杀待核销</div>
                <div class="number-box">
                  <div class="number">{{bottomText.seckillWaitAmount}}<span class="unit"> 元</span></div>
                  <!-- <div class="number">{{bottomText.seckillRefundAmount}}<span class="unit"> 元</span></div> -->
                </div>
                <div class="row">
                  <span class="key">累计待核销</span>
                  <div>{{bottomText.totalWaitSeckillVerification}} 元</div>
                </div>
                <div class="row">
                  <span class="key">今日待核销：{{bottomText.todayWaitSeckillVerification}}元</span>
                  <div class="value">较昨天日：<span :style="{ color: numberTypeColor(bottomText.dayChainWaitSeckillVerification) }">{{numberTypeSymbol(bottomText.dayChainWaitSeckillVerification)}}{{bottomText.dayChainWaitSeckillVerification}}%</span></div>
                </div>
                <!-- <div class="row">
                  <span class="key">今日退款： {{bottomText.todaySeckillRefund}}元</span>
                  <div class="value">较昨天日：<span :style="{ color: numberTypeColor(bottomText.dayChainSeckillRefund) }">{{numberTypeSymbol(bottomText.dayChainSeckillRefund)}}{{bottomText.dayChainSeckillRefund}}%</span></div>
                </div> -->
              </div>
            </div>
          </div>
          <div class="card-item">
            <div class="head-box">
              <span>拼团数据</span>
              <el-link class="link" type="success" :underline="false" @click="$router.push({ name: 'groupData' })">查看更多</el-link>
            </div>
            <div class="card-item-box">
              <div class="item">
                <div class="title">拼团人数 | 总金额</div>
                <div class="number-box">
                  <div class="number">{{bottomText.groupNum}}<span class="unit"> 人</span></div>
                  <div class="number">{{bottomText.groupAmount}}<span class="unit"> 元</span></div>
                </div>
                <div class="row">
                  <span class="key">累计人数 | 总金额</span>
                  <div>{{bottomText.totalGroupNum}}人/{{bottomText.totalGroup}}元</div>
                </div>
                <div class="row">
                  <span class="key">今日拼团人数：{{bottomText.todayGroupNum}} 人</span>
                  <div class="value">较昨天日：<span :style="{ color: numberTypeColor(bottomText.dayChainGroupNum) }">{{numberTypeSymbol(bottomText.dayChainRefund)}}{{bottomText.dayChainGroupNum}}%</span></div>
                </div>
                <div class="row">
                  <span class="key">今日拼团金额：{{bottomText.todayGroup}} 元</span>
                  <div class="value">较昨天日：<span :style="{ color: numberTypeColor(bottomText.dayChainGroup) }">{{numberTypeSymbol(bottomText.dayChainRefund)}}{{bottomText.dayChainGroup}}%</span></div>
                </div>
              </div>
              <div class="item">
                <div class="title">拼团待核销 | 退款</div>
                <div class="number-box">
                  <div class="number">{{bottomText.groupWaitAmount}}<span class="unit"> 元</span></div>
                  <div class="number">{{bottomText.groupRefundAmount}}<span class="unit"> 元</span></div>
                </div>
                <div class="row">
                  <span class="key">累计待核销 | 退款数</span>
                  <div>{{bottomText.totalWaitGroupVerification}}元/{{bottomText.totalRefundGroup}}元</div>
                </div>
                <div class="row">
                  <span class="key">今日待核销：{{bottomText.todayWaitGroupVerification}}元</span>
                  <div class="value">较昨天日：<span :style="{ color: numberTypeColor(bottomText.dayChainWaitGroupVerification) }">{{numberTypeSymbol(bottomText.dayChainRefund)}}{{bottomText.dayChainWaitGroupVerification}}%</span></div>
                </div>
                <div class="row">
                  <span class="key">今日退款：{{bottomText.todayRefundGroup}}元</span>
                  <div class="value">较昨天日：<span :style="{ color: numberTypeColor(bottomText.dayChainRefundGroup) }">{{numberTypeSymbol(bottomText.dayChainRefundGroup)}}{{bottomText.dayChainRefundGroup}}%</span></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import linChart from "./components/line-chart";
import barChart from "./components/bar-chart";
import mapChart from "./components/map-chart";
import officeChart from "./components/office-chart";
import dealerChart from "./components/dealer-chart";
import barLarge from "./components/bar-large";
import moment from "moment"
export default {
  name: "chartPage",
  components: {
    linChart,
    barChart,
    mapChart,
    officeChart,
    dealerChart,
    barLarge,
  },
  data() {
    return {
      officeList: [],
      value: "",
      value1: "",
      radio3: "",
      radio4: "",
      activeName: "",
      totalText: {},
      bottomText: {},
      loading: false,
      loading2: false,
      loading3: false,
      loadingAll: false,
      orgList: [],
      cusList: [],
      largeList: [],
      searchForm: {
        type: 1,
        orgCode: '',
        time: [moment().subtract(1, "months").format("YYYY-MM-DD 00:00:00"), moment().format("YYYY-MM-DD 23:59:59")],
        findType: 1,
        timeType: '',
      },
      typeList: [
        {label: 1, name: "销售额"},
        {label: 2, name: "活动创建数"},
        {label: 3, name: "活动参与数"},
        {label: 4, name: "报名人数"},
        {label: 5, name: "用户拉新数"},
      ],
      findTypeList: [
        {value: 1, name: '销售总额'},
        {value: 2, name: '访问总量'},
        {value: 3, name: '总顾客数'},
        {value: 4, name: '报名人数'},
        {value: 5, name: '报名退款'},
        {value: 6, name: '报名待核销'},
        {value: 7, name: '秒杀人数'},
        {value: 8, name: '秒杀待核销'},
        {value: 9, name: '拼团人数'},
        {value: 10, name: '拼团退款'},
        {value: 11, name: '拼团待核销'},
        {value: 12, name: '总待提现'},
        {value: 13, name: '总提现'},
      ],
      loadingIndex: 0,
      pickerOptions: {
        disabledDate(time) {
          const now = new Date(); // 获取当前时间
          const oneYearAgo = new Date(now.getFullYear() - 1, now.getMonth(), now.getDate()); // 获取一年前的时间
          return time.getTime() < oneYearAgo.getTime() 
        }
      },
      signUpSuccessRate: {
        closingOrderNum: 0,
        closingRate: 0,
        totalOrderNum: 0,
      }
    };
  },
  watch: {
    loadingIndex(val,old) {
      if(val == 5) {
        setTimeout(() => {
          this.loadingAll.close()
        }, 500);
      }
    }
  },
  mounted() {
    this.loadingAll = this.$loading({
      lock: true,
      text: "Loading",
      spinner: "el-icon-loading",
      background: "rgba(255, 255, 255, 0.7)",
    });
    this.queryDataList();
    this.getOrgList();
    this.rankingDataList();
    this.rangeQueryDataList('first');
    this.activityDataList();
    this.queryClosingRate()
  },
  methods: {
    init() {
      this.getOrgList();
      this.rankingDataList();
      this.rangeQueryDataList();
      this.activityDataList();
    },
    numberTypeColor(val) {
      return Number(val) >= 0 ? '#24c69a' : 'red'
    },
    numberTypeSymbol(val) {
      return Number(val) >= 0 ? '+' : ''
    },
    queryClosingRate() {
      this.$api.home.queryClosingRate().then(res => {
        if (res.data) {
          this.signUpSuccessRate = res.data
        }
      })
    },
    queryDataList() {
      this.$api.home.queryDataList().then((res) => {
        this.totalText = res.data;
      }).finally(_=>{
        this.loadingIndex += 1
      });
    },
    getOrgList() {
      this.$api.home.getOrgList().then((res) => {
        this.$refs.chinaMap.init()
        this.officeList = res.data;
      }).finally(_=>{
        this.loadingIndex += 1
      });
    },
    rankingDataList() {
      this.loading = true
      let { time, orgCode, type } = this.searchForm
      let data = {
        orgCode: orgCode,
        startTime: time ? time[0] : '',
        endTime: time ? time[1] : '',
        type: type
      }
      this.$api.home.rankingDataList(data).then((res) => {
        this.orgList = res.data.orgList;
        this.cusList = res.data.cusList;
        this.$refs.office.init()
        this.$refs.dealer.init()
      }).finally(_=>{
        this.loadingIndex += 1
        this.loading = false
      });
    },
    rangeQueryDataList(type) {
      this.loading2 = true
      let { time, orgCode, timeType, findType } = this.searchForm
      let data = {
        filterData: {
          orgCode: orgCode,
          startTime: time ? time[0] : '',
          endTime: time ? time[1] : '',
          type: timeType,
          findType: findType
        },
        pageNum: 1,
        pageSize: 99999
      }
      if(!timeType) {
        delete data.filterData.type
      }else {
        delete data.filterData.startTime
        delete data.filterData.endTime
      }
      this.$api.home.rangeQueryDataList(data).then((res) => {
        this.largeList = res.data.list
        this.$refs.large.init()
      }).finally(_=>{
        this.loading2 = false
        this.loadingIndex += 1
      });
    },
    activityDataList(type) {
      this.loading3 = true
      let { time, orgCode, } = this.searchForm
      let data = {
        orgCode: orgCode,
        startTime: time ? time[0] : '',
        endTime: time ? time[1] : '',
      }
      this.$api.home.activityDataList(data).then((res) => {
        this.bottomText = res.data
        console.log(this.bottomText);
      }).finally(_=>{
        this.loading3 = false
        this.loadingIndex += 1;
      });
    },
    timeChange() {
      this.$set(this.searchForm,'timeType','')
      this.init()
    },
    orgCodeChange(val) {
      this.searchForm.orgName = val ? this.officeList.find(v=>v.code == val).name : ''
      this.init()
    },
    mapSearch(name) {
      this.officeList.forEach(v=>{
        if(v.name.includes(name)) {
          this.$set(this.searchForm,'orgCode',v.code)
          this.init()
        }
      })
    },
    exportData() {
      let { orgCode, findType, timeType, time } = this.searchForm
      console.log(this.searchForm);
      let data = {
        orgCode,
        findType,
        type: timeType,
        startTime: time ? time[0] : '',
        endTime: time ? time[1] : '',
      }
      if(!timeType) {
        delete data.type
      }else {
        delete data.startTime
        delete data.endTime
      }
      this.$api.common.doExport(`rangeQueryDataList_${this.searchForm.findType}`, data).then(() => {
        this.$message.success("导出操作成功，请前往导出记录查看详情");
      });
    }
  },
};
</script>

<style lang="stylus" scoped>
.page-box {
  height: calc(98%);
  overflow: auto;
  margin: 5px 15px 0;
  background: rgb(232,232,232);
  .content {
    min-width: 1290px;
    .card-1 {
      display: flex;
      padding:20px;
      background: #fff;
      .card-item {
        flex: 1;
        border: 1px solid #ccc;
        margin-right: 10px;
        padding: 20px 40px;
        border-radius: 2px;
        cursor: pointer
      }
      .card-item:last-child {
        margin-right: 0px;
      }
      .title-box {
        display: flex;
        justify-content: space-between;
        color: #999999;
      }
      .number {
        font-size: 22px;
        margin-top: 10px;
      }
      .row-1 {
        display: flex;
        justify-content: space-between;
        color: #999999;
        margin-top: 26px;
        .top {
          color: rgb(143,217,107);
          margin: 6px;
        }
        .bottom {
          color: red;
          margin: 6px;
        }
      }
      .line {
        height: 36px;
        margin-top: 16px;
      }
      .row-2 {
        color: rgb(133,135,133);
        font-size: 15px;
        margin-top: 20px;
        padding-top: 10px;
        border-top: 1px solid rgba(133,135,133, 0.2);
        .row-2-number {
          margin-left: 10px;
        }
      }
      .item4 {
        margin-top:30px;
      }
    }
    .card-2 {
      padding:20px;
      margin-top: 5px;
      background: #fff;
      .search-box {
        display: flex;
        .label {
          color: #999;
        }
        .select-box {
          .data-picker {
            margin-left:10px;
          }
        }
        .tab-select {
          margin: 0 20px;
        }

      }
      .card-box {
        display: flex;
        .card-item {
          flex: 1;
          height: 340px;
          border-right: 1px solid #ccc;
          .head-box {
            display: flex;
            justify-content: space-between
            font-size: 16px;
            padding: 20px 20px 0 20px;
            .link {
              color: rgb(46,181,146)
            }
          }
        }
        .card-item:last-child {
          border-right: 0;
        }
      }
    }
    .card-3 {
      padding:20px;
      margin-top: 5px;
      background: #fff;
        .chatsTitle {
          font-size: 16px;
          font-weight: bold;
          margin-bottom: 20px
        }
      .head-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .head-left {
          .label {
            margin-right: 10px;
          }
          .tabs {
            width: 800px;
          }
        }
        .head-right {
          .group {
            margin-right: 20px;
          }
        }
        .label{
          color: #999
          font-weight: normal
          font-size: 14px
          margin-right: 0px !important
          margin-left: 20px
        }
      }
      .chart {
        width: 100%;
        height: 300px;
      }
    }
    .head-box {
      display: flex;
      justify-content: space-between;
      font-size: 16px;
      font-weight: bold;
      .link {
        color: rgb(46,181,146);
      }
    }
    .card-4 {
      padding:20px;
      margin-top: 5px;
      background: #fff;
      .card-item-box {
        display: flex;
        margin-top: 20px;
        .item {
          flex: 1;
          .title {
            color: #999;
            margin-bottom: 6px;
          }
          .number {
            font-size: 18px;
            margin-bottom: 6px;
            .unit {
              font-size: 10px;
            }
          }
          .row-text {
            color: #999;
          }
          .row {
            color: #999;
            display: flex;
            margin-top: 6px;
            .row-left {
              margin-right: 20px;
            }
            .row-right {
              span {
                color: #24c69a
              }
            }
          }
        }
      }
    }
    .card-5 {
      display: flex;
      margin-top: 5px;
      .card-item {
        flex: 1;
        padding:20px;
        background: #fff;
        .card-item-box {
          display: flex;

          margin-top: 20px;
          .item {
            color: #999;
            flex: 1;
            .number-box {
              display: flex;
              align-items: center;
              margin-top: 6px;
              .number {
                color: #000;
                font-size: 18px;
                border-right: 1px solid #999;
                padding-right: 10px;
                margin-right: 10px;
                .unit {
                  font-size: 10px;
                }
              }
              .number:last-child {
                border-right: none;
                padding-right: 0;
                margin-right: 0;
              }
            }
            .row {
              display: flex;
              color: #999;
              margin-top: 6px;
              .key {
                margin-right: 20px;
              }
            }
          }
        }
      }
      .left {
        margin-right: 5px;
      }
    }
  }
  .el-icon-warning-outline {
    cursor: pointer
  }
}
</style>
